export interface NigpCode {
  code: string;       // e.g. "208-11" or "208"
  title: string;
  classCode: string;  // e.g. "208"
  isClass: boolean;   // true for 3-digit class, false for 5-digit item
}

export const COMPLETE_NIGP_CODES: NigpCode[] = [
  // Class 031 - Air Conditioning, Heating, and Ventilating Equipment
  { code: "031", title: "Air Conditioning, Heating, and Ventilating Equipment, Parts and Accessories", classCode: "031", isClass: true },
  { code: "031-05", title: "Air Conditioners, Commercial and Industrial", classCode: "031", isClass: false },
  { code: "031-27", title: "Filters, Air Conditioning and Heating", classCode: "031", isClass: false },
  { code: "031-45", title: "Heating Equipment, Electric", classCode: "031", isClass: false },
  { code: "031-67", title: "Ventilating Equipment, Roof and Wall Power", classCode: "031", isClass: false },

  // Class 150 - Builder's Supplies
  { code: "150", title: "Builder's Supplies", classCode: "150", isClass: true },
  { code: "150-10", title: "Ceiling Panels and Tiles", classCode: "150", isClass: false },
  { code: "150-33", title: "Doors and Frames, Metal", classCode: "150", isClass: false },
  { code: "150-55", title: "Lumber, Treated", classCode: "150", isClass: false },
  { code: "150-77", title: "Wallboard, Gypsum and Plasterboard", classCode: "150", isClass: false },

  // Class 208 - Computer Software for Microcomputers (Systems, Utilities, Applications)
  { code: "208", title: "Computer Software for Microcomputers (Systems, Utilities, Applications)", classCode: "208", isClass: true },
  { code: "208-11", title: "Application Software, Microcomputer", classCode: "208", isClass: false },
  { code: "208-37", title: "Database Software, Microcomputer", classCode: "208", isClass: false },
  { code: "208-54", title: "Internet and Web Software, Microcomputer", classCode: "208", isClass: false },
  { code: "208-80", title: "Software, Microcomputer, Utility", classCode: "208", isClass: false },

  // Class 450 - Hardware and Related Items
  { code: "450", title: "Hardware and Related Items", classCode: "450", isClass: true },
  { code: "450-06", title: "Batteries, Dry Cell (Except Transistor and Radio)", classCode: "450", isClass: false },
  { code: "450-24", title: "Hose and Hose Fittings, Garden", classCode: "450", isClass: false },
  { code: "450-41", title: "Locks, Keyless Entry and Electronic", classCode: "450", isClass: false },
  { code: "450-55", title: "Rope, Nylon and Synthetic", classCode: "450", isClass: false },

  // Class 545 - Machinery and Hardware, Industrial
  { code: "545", title: "Machinery and Hardware, Industrial", classCode: "545", isClass: true },
  { code: "545-15", title: "Drills, Industrial Quality", classCode: "545", isClass: false },
  { code: "545-29", title: "Generators, Steam and Diesel", classCode: "545", isClass: false },
  { code: "545-42", title: "Pumps, Centrifugal and Industrial", classCode: "545", isClass: false },

  // Class 655 - Photographic Equipment, Film, and Supplies
  { code: "655", title: "Photographic Equipment, Film, and Supplies", classCode: "655", isClass: true },
  { code: "655-15", title: "Cameras, Digital (Still)", classCode: "655", isClass: false },
  { code: "655-39", title: "Film, Photographic (All Formats)", classCode: "655", isClass: false },
  { code: "655-78", title: "Projectors and Video Presentation Gear", classCode: "655", isClass: false },

  // Class 740 - Refrigeration Equipment and Accessories
  { code: "740", title: "Refrigeration Equipment and Accessories", classCode: "740", isClass: true },
  { code: "740-17", title: "Cold Storage Doors and Hardware", classCode: "740", isClass: false },
  { code: "740-55", title: "Refrigerators, Commercial", classCode: "740", isClass: false },

  // Class 800 - Shoes and Boots
  { code: "800", title: "Shoes and Boots", classCode: "800", isClass: true },
  { code: "800-24", title: "Boots, Safety (Steel Toe, etc.)", classCode: "800", isClass: false },
  { code: "800-50", title: "Shoes, Athletic and Casual", classCode: "800", isClass: false },

  // Class 910 - Building Maintenance, Installation and Repair Services
  { code: "910", title: "Building Maintenance, Installation and Repair Services", classCode: "910", isClass: true },
  { code: "910-04", title: "Air Duct Cleaning Services", classCode: "910", isClass: false },
  { code: "910-39", title: "Janitorial Services", classCode: "910", isClass: false },
  { code: "910-54", title: "Painting, Maintenance and Repair Services", classCode: "910", isClass: false },
  { code: "910-82", title: "Wiring Services, Electrical", classCode: "910", isClass: false },

  // Class 912 - Construction Services, General
  { code: "912", title: "Construction Services, General", classCode: "912", isClass: true },
  { code: "912-20", title: "Bridge Construction Services", classCode: "912", isClass: false },
  { code: "912-44", title: "Excavation and Grading Services", classCode: "912", isClass: false },
  { code: "912-76", title: "Highway and Street Construction", classCode: "912", isClass: false },

  // Class 915 - Communications and Media Related Services
  { code: "915", title: "Communications and Media Related Services", classCode: "915", isClass: true },
  { code: "915-09", title: "Audio and Video Production Services", classCode: "915", isClass: false },
  { code: "915-22", title: "Conference Call Services", classCode: "915", isClass: false },
  { code: "915-72", title: "Public Relations Services", classCode: "915", isClass: false },
  { code: "915-96", title: "Web Page Design, Hosting, and Maintenance Services", classCode: "915", isClass: false },

  // Class 918 - Consulting Services
  { code: "918", title: "Consulting Services", classCode: "918", isClass: true },
  { code: "918-29", title: "Computer Consulting", classCode: "918", isClass: false },
  { code: "918-32", title: "Consulting Services (Not Otherwise Classified)", classCode: "918", isClass: false },
  { code: "918-75", title: "Management Consulting", classCode: "918", isClass: false },
  { code: "918-90", title: "Strategic Technology Planning Consulting", classCode: "918", isClass: false },

  // Class 920 - Data Processing, Computer, Programming, and Software Services
  { code: "920", title: "Data Processing, Computer, Programming, and Software Services", classCode: "920", isClass: true },
  { code: "920-02", title: "Access Services, Data", classCode: "920", isClass: false },
  { code: "920-03", title: "Application Service Provider (ASP) Services", classCode: "920", isClass: false },
  { code: "920-14", title: "Applications Software (For Mainframe Systems)", classCode: "920", isClass: false },
  { code: "920-37", title: "Disaster Recovery Services, Data", classCode: "920", isClass: false },
  { code: "920-45", title: "Software Maintenance and Support Services", classCode: "920", isClass: false },

  // Class 939 - Equipment Maintenance and Repair Services for Computers, Office, etc.
  { code: "939", title: "Equipment Maintenance and Repair Services for Computers, Office, etc.", classCode: "939", isClass: true },
  { code: "939-21", title: "Computer Maintenance and Repair, Microcomputers", classCode: "939", isClass: false },
  { code: "939-54", title: "Office Machine Maintenance and Repair", classCode: "939", isClass: false }
];
